/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './ShopDetailsPage.module.scss';

const SDPPayment = ({ shopInfo }) => {
  return (
    (shopInfo.payment_methods && shopInfo.payment_methods.length > 0 && (
      <div className={styles.shopPaymentMethods}>
        <h3 className={styles.accoladeHeading}>
          <FormattedMessage id="shop.paymentMethod" defaultMessage="Betaalmethode" />
        </h3>
        {shopInfo.payment_methods.map((method, index) => {
          return (
            // Image dimensions: w=100, h=35
            <img
              src={method.image}
              alt={method.name}
              key={method + index}
              title={method.name}
              heigth="35"
              width="100"
            />
          );
        })}
      </div>
    )) ||
    null
  );
};

export default SDPPayment;
